import { Component, Input, OnInit } from '@angular/core';
import {
  DialogRef,
  DialogService,
} from '@cyborg-monorepo/common/angular/cyborg-ui';
import { HuntPackageRecord } from '@cyborg-monorepo/hunter/common';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { AuthService } from '../../../../auth/auth.service';
import { CalendlyService } from '../../services/calendly.service';
import { PremiumDialogComponent } from '../dialogs/premium-dialog/premium-dialog.component';
import {
  TrackingEventEnum,
  TrackingService,
} from '../../../../tracking/tracking.service';
@Component({ standalone: false, 
  selector: 'cyborg-trial-lock-unlock',
  templateUrl: './trial-lock-unlock.component.html',
  styleUrls: ['./trial-lock-unlock.component.scss'],
})
export class TrialLockUnlockComponent implements OnInit {
  public locked$: Observable<boolean>;
  @Input() public huntPackage: Partial<HuntPackageRecord>;
  constructor(
    private authService: AuthService,
    public dialog: DialogService,
    public calendlyService: CalendlyService,
    public trackingService: TrackingService,
  ) {}
  public ngOnInit(): void {
    this.locked$ = this.authService.user$.pipe(
      map((profile) => {
        const inTrial = profile.company.status === 'trial';
        return inTrial && !this.huntPackage.community;
      }),
    );
  }

  public openPremiumDialog(): void {
    this.trackingService.trackEvent(
      TrackingEventEnum.COMMUNITY_PREMIUM_DIALOG_OPENED,
    );
    const dialogRef: DialogRef = this.dialog.open(PremiumDialogComponent, {
      panelClass: 'full-panel',
    });

    dialogRef.afterClosed().subscribe((talkToCyborg: boolean) => {
      if (talkToCyborg) {
        this.calendlyService.talkToCyborg();
      } else {
        this.trackingService.trackEvent(
          TrackingEventEnum.COMMUNITY_PREMIUM_DIALOG_ABANDONED,
        );
      }
    });
  }
}
